import {connect} from 'react-redux';
import Component from '../components/ListItems';
// import {signOut} from '../actions';
import {mapListItemsToProps} from '../selectors';

export default connect(mapListItemsToProps)(Component);